<template>
  <Row>
    <Col span="24">
    <Card>
      <p slot="title">变量列表</p>
      <span slot="extra">
        <Select v-model="status" style="width:120px" @on-change="fetchData" placeholder="请选择状态" clearable>
          <Option v-for="(status,key) in statuses" :value="key" :key="key">{{ status }}</Option>
        </Select>
        <Select v-model="type" style="width:120px" @on-change="fetchData" placeholder="请选择类型" clearable>
          <Option v-for="(type,key) in types" :value="key" :key="key">{{ type }}</Option>
        </Select>
        <Input v-model="queryStr" placeholder="请输入关键词查询" @on-change="fetchData" style="width: 300px"></Input>
        <Button type="success" @click="showAdd = true"><Icon type="plus"></Icon> 添加</Button>
      </span>
      <Table stripe :columns="attributes" :data="variables" v-if="variables">
        <template slot-scope="{ row }" slot="type">
            {{ types[row.type] }}
        </template>
      </Table>
      <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    </Card>
    <Modal
        v-model="showAdd"
        title="添加变量"
        :styles="{bottom:'0px'}" >
        <add-variable ref="addVariable" @refresh="refresh"></add-variable>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showEdit"
        title="编辑变量信息"
        :styles="{bottom:'0px'}" >
        <edit-variable ref="editVariable" :meta="meta" @refresh="refresh"></edit-variable>
        <div slot="footer" v-show="false"></div>
    </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListVariables, DeleteVariable } from '@/api/variable'
import AddVariable from '@/components/variable/AddVariable'
import EditVariable from '@/components/variable/EditVariable'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'list-variables',
  data: function () {
    return {
      variables: [],
      queryStr: '',
      meta: '',
      showAdd: false,
      showEdit: false,
      pageMeta: {},
      status: '1',
      type: null,
      statuses: {
        '1': '激活',
        '0': '禁用'
      },
      types: {
        'text': '短文本',
        'long': '长文本',
        'int': '整数',
        'float': '小数',
        'radio': '单选',
        'checkbox': '多选',
        'date': '日期',
        'datetime': '日期时间',
        'time': '时间'
      },
      attributes: [{
        title: '变量次序',
        key: 'order',
        sortable: true
      },
      {
        title: '变量标签',
        key: 'label',
        sortable: true
      },
      {
        title: '变量名称',
        key: 'var',
        sortable: true
      },
      {
        title: '变量类型',
        key: 'type',
        sortable: true,
        slot: 'type'
      },
      {
        title: '单位',
        key: 'unit'
      },
      {
        title: '编码列表',
        key: 'codelist'
      },
      {
        title: '宽度',
        key: 'width'
      },
      {
        title: '状态',
        key: 'statusText'
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: (h, params) => {
          const icon = params.row.status === 1 ? 'ios-trash' : 'ios-refresh'
          return h('div', [
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: 'ios-create-outline'
              },
              on: {
                click: () => {
                  this.edit(params.row.id)
                }
              }
            }),
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: icon
              },
              on: {
                click: () => {
                  this.remove(params.row.id)
                }
              }
            })
          ])
        }
      }]
    }
  },
  components: {
    'pagination': Pagination,
    'add-variable': AddVariable,
    'edit-variable': EditVariable
  },
  created: function () {
    this.fetchData()
  },
  props: ['domainid'],
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['VariableSearch[status]'] = this.status
      query['VariableSearch[type]'] = this.type
      query['VariableSearch[domainid]'] = this.domainid
      query['queryStr'] = this.queryStr
      ListVariables(query).then(async res => {
        this.variables = res.items
        this.pageMeta = res._meta
      })
    },
    refresh: function () {
      this.fetchData()
      this.showAdd = false
      this.showEdit = false
    },
    edit: function (id) {
      this.meta = id
      this.$refs.editVariable.init(id)
      this.showEdit = true
    },
    remove: function (id) {
      DeleteVariable(id).then(async res => {
        this.refresh()
      })
    }
  }
}
</script>
